import { SettingsApi } from '@itsrever/rever-api'
import { apiClient } from '@/infrastructure/api'
import {
  GroupRouting,
  RoutingRule,
  Warehouse,
  WarehouseUpdate
} from '@/domain/warehouses'
import { toGroupRouting, toPbConfigs, toPbWarehouse, toWarehouse } from './dto'

const settingsApi = new SettingsApi(undefined, undefined, apiClient)

async function findGroupWarehouses(
  group: string,
  signal?: AbortSignal
): Promise<Warehouse[]> {
  const response = await settingsApi.findWarehousesByGroupV2(
    { ecommerceGroup: group },
    { signal }
  )
  return (response.data.warehouses ?? []).map(toWarehouse)
}

// Returns the saved id, new for a warehouse the group did not have.
async function saveGroupWarehouse(group: string, warehouse: WarehouseUpdate) {
  const response = await settingsApi.saveWarehousesV2({
    ecommerceGroup: group,
    pbSaveWarehousesV2Req: {
      ecommerce_group: group,
      warehouses: [toPbWarehouse(warehouse, group)]
    }
  })
  return response.data.ids?.[0] ?? warehouse.id
}

async function deleteGroupWarehouse(group: string, id: string) {
  await settingsApi.deleteWarehousesV2({
    ecommerceGroup: group,
    pbDeleteWarehousesV2Request: { ecommerce_group: group, ids: [id] }
  })
}

async function findGroupRouting(
  group: string,
  signal?: AbortSignal
): Promise<GroupRouting> {
  const response = await settingsApi.getGroupWarehouseConfigsV2(
    { ecommerceGroup: group },
    { signal }
  )
  return toGroupRouting(response.data)
}

async function saveGroupRules(group: string, rules: RoutingRule[]) {
  await settingsApi.saveGroupWarehouseConfigsV2({
    ecommerceGroup: group,
    pbSaveGroupWarehouseConfigsV2Request: {
      ecommerce_group: group,
      warehouse_configs: toPbConfigs(rules)
    }
  })
}

async function saveStoreRules(ecommerceId: string, rules: RoutingRule[]) {
  await settingsApi.saveEcommerceWarehouseConfigsV2({
    ecommerceId,
    pbSaveWarehouseConfigRequest: {
      ecommerce_id: ecommerceId,
      warehouse_configs: toPbConfigs(rules)
    }
  })
}

async function resetStoreRules(ecommerceId: string) {
  await settingsApi.deleteWarehouseConfigOverrideV2({ ecommerceId })
}

export default {
  findGroupWarehouses,
  saveGroupWarehouse,
  deleteGroupWarehouse,
  findGroupRouting,
  saveGroupRules,
  saveStoreRules,
  resetStoreRules
}
